<template>
  <div class="queue-type-select w-100">
    <div class="queue-type-select__item type-button">
      <tooltip v-bind="get_tooltip_props('all')">
        <i-button type="text" :class="get_classes('all')" @click="set_type('all')">
          <span>&nbsp;</span>
        </i-button>
      </tooltip>
      <span class="type-button__title">{{ $t(`pbx.queue.type.all.title`) }}</span>
    </div>

    <div class="queue-type-select__item type-button">
      <tooltip v-bind="get_tooltip_props('random')">
        <i-button type="text" :class="get_classes('random')" @click="set_type('random')">
          <span>&nbsp;</span>
        </i-button>
      </tooltip>
      <span class="type-button__title">{{ $t(`pbx.queue.type.random.title`) }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: ''
      }
    },

    methods: {
      set_type: function(val) {
        this.$emit('input', val);
      },

      get_classes: function(type) {
        return {
          active: type === this.value,
          'type-button__btn': true,
          'type-button__btn--random': type === 'random',
          'type-button__btn--all': type === 'all'
        };
      },

      get_tooltip_props: function(type) {
        return {
          'max-width': 180,
          theme: 'light',
          class: 'queue__tooltip',
          content: this.$t(`pbx.queue.type.${type}.description`)
        };
      }
    }
  };
</script>

<style lang="scss">
  .queue-type-select {
    display: inline-block;

    &__item {
      & + & {
        margin-left: 10px;
      }
    }
  }

  .type-button {
    display: inline-block;

    &__title {
      display: block;
      margin-top: 2px;
      width: 100%;
      font-size: 10px;
      line-height: 12px;
      text-align: center;
      color: $blue-grey-light;
    }

    &__btn {
      display: inline-block;
      border: 1px solid $primary;
      box-sizing: border-box;
      border-radius: 3px;
      width: 40px;
      height: 40px;
      padding: 0;

      &:hover,
      &.active {
        border: 1px solid $primary;
        background-color: $primary;
      }

      & > span {
        width: 100%;
        height: 100%;
        display: inline-block;
        background-repeat: no-repeat;
        background-position: center;
        mask-repeat: no-repeat;
        mask-position: center;
      }

      @each $type in ('all', 'random') {
        &--#{$type} {
          span {
            background-image: url('/img/icons/pbx/queue-type-#{$type}.svg');
          }

          &:hover span,
          &.active span {
            background: #fff;
            mask-image: url('/img/icons/pbx/queue-type-#{$type}.svg');
          }
        }
      }
    }
  }
</style>
